// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-military-information{margin-bottom:20px}.contact-military-information .military-information .flex-static .edit-modal{width:50px}.contact-military-information .military-information .flex-static .edit-modal p{display:inline-block;margin-left:5px}", ""]);
// Exports
module.exports = exports;
